<template>
  <div v-if="loading" class="loader-block" :style="{ minHeight }">
    <loader :loading="true" :title="title" />
  </div>
</template>

<script>
import Loader from '../Loader/index.vue'

/**
 * Контент ачаалагдах хүртэл түүний оронд харуулах loader блок.
 *
 * Loader нь position:absolute, height:100% тул эцэг элемент өндөргүй бол
 * харагдахгүй. Loader.mounted() эцгийн position-ыг зохицуулдаг ч өндрийг нь
 * зохицуулдаггүй тул энд minHeight-аар зай нөөцөлж өгнө.
 *
 * Хэрэглээ:
 *   <loader-block :loading="loadingStatus" />
 *   <loader-block :loading="loading" min-height="120px" :title="$t('common.loading')" />
 */
export default {
  name: 'LoaderBlock',
  components: { Loader },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    minHeight: {
      type: String,
      default: '240px',
    },
    title: {
      type: String,
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>
.loader-block {
  position: relative;
  width: 100%;
}
</style>
